import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TermsAPI from "../api/TermsAPI";

const TermsAndConditions = () => {
  const [termsAndConditions, setTermsAndConditions] = useState("");

  useEffect(()=>{
    let fetch = async ()=>{
      let res = await TermsAPI.getTermsConditions();
      setTermsAndConditions(res.data.description)
    }
    fetch();
  }, [])
  return (
    <div className="custom-trips-terms-and-condition">
        <h3 className="text-center pt-4 pb-3 mb-0" style={{color:"#259dd1"}}>Terms & Conditions</h3>
      <div className="container d-flex justify-content-center flex-column align-items-center">
        <div className="col-lg-12 custom-t-and-c-main-cont" dangerouslySetInnerHTML={{ __html: termsAndConditions }} ></div>
        {/* <div className="col-lg-12 custom-t-and-c-main-cont">
          {termsAndConditions}
        </div> */}
      </div>
    </div>
  );
};

export default TermsAndConditions;  
